import React from 'react';
import { Link } from 'react-router-dom';
import './order-success-styles.css';

function OrderSuccess() {
    return (
        <div className="order-success-page">
            <div className="success-content">
                <div className="success-icon">✓</div>
                <h1>Order Placed Successfully!</h1>
                <p>Thank you for your order. We'll send you a confirmation email shortly.</p>
                <div className="success-actions">
                    <Link to="/" className="home-btn">Continue Shopping</Link>
                </div>
            </div>
        </div>
    );
}

export default OrderSuccess;

